// extracted by mini-css-extract-plugin
module.exports = {"customizedLight":"customizedLight___2yXJP","inputName":"inputName___1xgaz","customizedDark":"customizedDark___FGSc_"};